import pagination from '@iso/lib/helpers/pagination';

const {
    actions: baseActions,
    types,
    reducer,
} = pagination('warehouseTypes');

const actions = {
    requestFetchWarehouseTypes: baseActions.request,
    fetchWarehouseTypesSucceeded: baseActions.succeeded,
    fetchWarehouseTypesFailed: baseActions.failed,
};

export { types, actions };

export default reducer;